var map = {
	"./1.jpg": 8623,
	"./2.jpg": 7972,
	"./3.jpg": 2065,
	"./4.jpg": 3710,
	"./5.jpg": 7634,
	"./6.jpg": 6102,
	"./event-banner.jpg": 640,
	"./event-banner2.jpg": 6749,
	"./event-banner3.jpg": 4453
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1314;